<template>
  <div class="video-format">
    <h2 class="format-title">视频比例</h2>
    <div
      v-for="item in ratioList"
      :class="[
        'format-screen',
        { 'format-screen-active': screenRatio === item.ratio }
      ]"
      :key="item.icon"
      @click="handleVisible(item)"
    >
      <div class="icon-wrap">
        <img
          :src="
            '/preview/icon/' +
            item.icon +
            (screenRatio !== item.ratio ? '-off.png' : '.png')
          "
          :alt="item.name"
        />
      </div>
      <div class="screen-info">
        <div class="screen-ratio">{{ item.name }}</div>
        <div class="screen-tips">{{ item.tips }}</div>
      </div>
      <a-tag
        color="rgba(0,127,255,.5)"
        v-if="screenRatio !== item.ratio && alternateTemplates[item.specs]"
        class="screen-ratio__tag"
      >
        模板
      </a-tag>
    </div>
    <div style="height: 18px"></div>
    <h2 class="format-title">视频分辨率</h2>
    <div class="format-screen-size-list">
      <div
        v-for="item in sizeList[sizeListKey]"
        :class="[
          'format-screen-size',
          { 'format-screen-size-active': item[2] === currentSize }
        ]"
        :key="item[0]"
        @click="handleSizeChange(item[0], item[2])"
      >
        <el-tag v-if="item[0] === 1080" type="warning" size="mini" style="position:absolute;right:-10px;top:-12px;">生成较慢</el-tag>
        <el-tag v-if="item[0] === 720" type="success" size="mini" style="position:absolute;right:-10px;top:-12px;">推荐</el-tag>
        {{ item[1] }}{{ item[0] }}P
      </div>
    </div>
    <h2 class="format-title hide-stamp-check">本片段专属设置</h2>
    <a-checkbox v-model="activeFragment.hideStamp">不打水印</a-checkbox>
    <a-modal
      title="修改视频比例"
      :visible="visible"
      @ok="handleNext"
      @cancel="handleCancel"
      cancelText="取消"
      okText="确认"
    >
      <a-radio-group v-model="nextBehavior" class="behavior-radio-group">
        <a-radio value="template">
          <div class="screen-ratio">更换为当前模板相应的{{ tips }} 模板</div>
          <div class="screen-tips">此操作将会清除当前所有片段设置的数据。</div>
        </a-radio>
        <a-radio value="resize">
          <div class="screen-ratio">仅更换当前比例为{{ tips }}</div>
          <div class="screen-tips">此操作将会影响原有元素的布局设置。</div>
        </a-radio>
      </a-radio-group>
    </a-modal>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { mapMutations, mapState, mapGetters } from 'vuex';

export default {
  name: "VideoFormat",
  data: function () {
    return {
      sizeList: {
        wide: [],
        square: [],
        rectangle: []
      },
      ratioList: [],
      visible: false,
      nextScreen: '',
      tips: '',
      nextRatio: 1,
      nextSpecs: null,
      nextBehavior: 'resize' // resize or template
    }
  },
  computed: {
    ...mapState(['screenRatio', 'screenHeight', 'userMeal', 'usedTemplateId', 'alternateTemplates']),
    ...mapGetters(['activeFragment']),
    currentSize: {
      get() {
        return this.screenHeight;
      },
      set(value) {
        this.$store.dispatch('setScreenHeight', value);
      }
    },
    sizeListKey() {
      const { screenRatio } = this;
      return screenRatio === 16 / 9 ? 'wide' : screenRatio === 1 ? 'square' : 'rectangle';
    }
  },
  mounted() {
    if (this.userMeal) {
      this.initData();
    }
  },
  methods: {
    ...mapMutations(['handleScreenRatio', 'handleFragments', 'handleScreenHeight', 'handleShowSubVideoClipList']),
    async handleOk() {
      if (this.nextBehavior === 'resize') {
        this.handleScreenRatio(this.nextRatio);
        let currentSize = this.currentSize
        if(currentSize === 1920){
          currentSize = 1080
        }else if(currentSize === 1280){
          currentSize = 720
        }else if(currentSize === 960){
          currentSize = 540
        }
        this.sizeList[this.nextScreen].forEach((size)=>{
          if(size[0] === currentSize){
            this.currentSize = size[2]
          }
        })
      } else {
        const template = this.alternateTemplates[this.nextSpecs];
        await this.$store.dispatch('applyVideoTemplate', {
          id: template.id,
          type: template.type,
          screenRatio: this.nextRatio,
          screenHeight: this.sizeList[this.nextScreen][0][2],
          method: 'replace'
        });
      }
      this.visible = false;
    },
    handleCancel: function () {
      this.visible = false;
    },
    handleVisible: function (screen) {
      console.log(this.usedTemplateId);
      if (this.screenRatio !== screen.ratio) {
        this.tips = screen.name;
        this.nextScreen = screen.icon;
        this.nextRatio = screen.ratio;
        this.nextSpecs = screen.specs;

        if (this.alternateTemplates[screen.specs]) {
          this.nextBehavior = 'template';
          this.visible = true;
        } else {
          this.nextBehavior = 'resize';
          this.handleNext();
        }
      }
    },
    handleNext() {
      Modal.confirm({
        title: `更换视频比例为 ${this.tips}?`,
        content: this.nextBehavior === 'resize' ? '此操作将会影响原有元素的布局设置。' : '此操作将会清除当前所有片段设置的数据。',
        onOk: this.handleOk
      });
    },

    handleSizeChange(type, size){
      if(this.currentSize !== size){
        if(type === 1080){
          this.$confirm('1080P的渲染生成时间较长，确定要选择1080P吗？', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.currentSize = size
          });
        }else{
          this.currentSize = size
        }
      }
    },    
    initData() {
      // let sizeAuth = this.userMeal[2].lower[17].value
      // sizeAuth.push('1080P')
      let sizeAuth = ["540P", "720P", "1080P"]
      if (sizeAuth.indexOf('720P') != -1 || sizeAuth.indexOf('540P') != -1 || sizeAuth.indexOf('1080P') != -1) {
        this.ratioList = [
          { specs: 1, name: '宽屏 (16:9)', icon: 'wide', tips: '适合PC端', ratio: 16 / 9 },
          { specs: 2, name: '方屏 (1:1)', icon: 'square', tips: '适合产品主图展示', ratio: 1 },
          { specs: 3, name: '竖屏 (9:16)', icon: 'rectangle', tips: '适合移动设备', ratio: 9 / 16 }
        ]
        if (sizeAuth.indexOf('1080P') != -1) {
          this.sizeList.wide.push([1080, '超清', 1080])
          this.sizeList.square.push([1080, '超清', 1080])
          this.sizeList.rectangle.push([1080, '超清', 1920])
        }
        if (sizeAuth.indexOf('720P') != -1) {
          this.sizeList.wide.push([720, '高清', 720])
          this.sizeList.square.push([720, '高清', 720])
          this.sizeList.rectangle.push([720, '高清', 1280])
          if (sizeAuth.indexOf('1080P') == -1) {
            this.currentSize = 720
          }
        }
        if (sizeAuth.indexOf('540P') != -1) {
          this.sizeList.wide.push([540, '标清', 540])
          this.sizeList.square.push([540, '标清', 540])
          this.sizeList.rectangle.push([540, '标清', 960])
          if (sizeAuth.indexOf('720P') == -1) {
            this.currentSize = 540
          }
        }
      }
    }
  },
  watch: {
    screenRatio() {
      this.handleShowSubVideoClipList(false)
    },
    userMeal(cur, prev) {
      if (cur && !prev) {
        this.initData();
      }
    }
  }
}
</script>

<style scoped>
.video-format {
  background: rgba(248, 248, 248, 1);
  padding: 13px;
  box-sizing: border-box;
}

.format-title {
  font-size: 14px;
  font-weight: 400;
  /* color: rgba(101, 102, 103, 1); */
  margin: 0;
}

.format-screen {
  height: 52px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(229, 229, 231, 1);
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 0 11px 0 0;
  box-sizing: border-box;
  cursor: pointer;
  color: #1e1e1e;
}

.icon-wrap {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.screen-info {
  flex: 1;
  margin-left: 4px;
}

.screen-ratio {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 2px;
}

.screen-ratio__tag {
  padding: 0 4px;
  line-height: 18px;
  border-radius: 2px;
  margin: 0;
}

.screen-tips {
  font-size: 12px;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
}

.format-screen-size-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.format-screen-size {
  width: 100px;
  height: 25px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 231, 1);
  font-size: 12px;
  font-weight: 500;
  color: rgba(101, 102, 103, 1);
  line-height: 25px;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
  position: relative;
}

.format-screen-active,
.format-screen-size-active {
  border: 1px solid rgba(0, 126, 255, 1);
}

.hide-stamp-check {
  margin: 16px 0 4px;
}

.behavior-radio-group {
  display: block;
}

.behavior-radio-group ::v-deep .ant-radio-wrapper {
  display: flex;
  border-radius: 2px;
  transition: 0.3s;
  margin: 0 0 12px;
  padding: 6px;
  padding-right: 24px;
  align-items: center;
  min-height: 50px;
}

.behavior-radio-group ::v-deep .ant-radio-wrapper:hover {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
}

.behavior-radio-group ::v-deep .ant-radio-wrapper-checked,
.behavior-radio-group ::v-deep .ant-radio-wrapper-checked:hover {
  color: #1890ff;
  box-shadow: 0 0 0 1px #1890ff;
}

.behavior-radio-group ::v-deep .ant-radio {
  position: absolute;
  right: 12px;
  top: 0;
  bottom: 0;
  width: 16px;
  height: 16px;
  margin: auto 0;
}
</style>
